export async function authedFetch({
  accessToken,
  apiBase,
  path,
  navigate,
  options = {},
}) {
  if (!accessToken) {
    navigate('/login', { replace: true });
    throw new Error('No active session');
  }

  const res = await fetch(`${apiBase}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) {
    navigate('/login', { replace: true });
    throw new Error('Unauthorised');
  }

  return res;
}